import type { EmptyArray } from '@mntn-dev/utility-types'

export function isNilOrEmptyArray<T>(
  array: T[] | null | undefined
): array is null | undefined | EmptyArray {
  return (array ?? []).length === 0
}
